import { z } from 'zod';

/**
 * Règles alignées sur `frontend/src/features/auth/schemas.ts` (elles-mêmes alignées sur
 * `PasswordPolicy` côté serveur, NIST SP 800-63B : la longueur prime, aucune règle de
 * composition). Dupliquées ici plutôt que partagées via `@pixlide/ui` : ce composant reste
 * propre à l'inscription publique de `frontend/`, et un unique formulaire de création de
 * compte back-office ne justifie pas de le déplacer dans le design system partagé.
 */
const PASSWORD_MIN_LENGTH = 12;
const PASSWORD_MAX_LENGTH = 128;

export const createPlatformAdminSchema = z.object({
  email: z
    .string()
    .min(1, "L'adresse email est obligatoire.")
    .email("L'adresse email n'est pas au bon format.")
    .max(320),

  firstName: z.string().min(1, 'Le prénom est obligatoire.').max(100),
  lastName: z.string().min(1, 'Le nom est obligatoire.').max(100),

  password: z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères.`)
    .max(PASSWORD_MAX_LENGTH, `Le mot de passe ne peut pas dépasser ${PASSWORD_MAX_LENGTH} caractères.`),
});

export type CreatePlatformAdminInput = z.infer<typeof createPlatformAdminSchema>;
